import Nullstack from 'nullstack';
export default function IconGrillOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-grill-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8 8h-3a6 6 0 0 0 6 6h2c.315 0 .624 -.024 .926 -.071m2.786 -1.214a5.99 5.99 0 0 0 2.284 -4.49l.004 -.225h-7"
  }), "   ", Nullstack.element("path", {
    d: "M18.827 18.815a2 2 0 1 1 -2.663 -2.633"
  }), "   ", Nullstack.element("path", {
    d: "M9 14l-3 6"
  }), "   ", Nullstack.element("path", {
    d: "M15 18h-8"
  }), "   ", Nullstack.element("path", {
    d: "M15 5v-1"
  }), "   ", Nullstack.element("path", {
    d: "M12 5v-1"
  }), "   ", Nullstack.element("path", {
    d: "M9 5v-1"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}